import {
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React from "react";
import "./Clients.css";
import dl_logo from "../../../Image/clients/dl_logo.png";
import futtaim_logo from "../../../Image/clients/futtaim_logo.png";
import gamble_logo from "../../../Image/clients/gamble_logo.png";
import Glencore_logo from "../../../Image/clients/Glencore_logo.png";
import nestle_logo from "../../../Image/clients/nestle-logo.png";
import zara_Logo from "../../../Image/clients/zara_Logo.png";

const useStyles = makeStyles({
  serviceHeading: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    padding: "30px 0",
  },
  serviceImg: {
    margin: "0 auto",
  },
});

const Client = () => {
  const classes = useStyles();
  return (
    <div>
      <Container>
        <div className="service">
          <Box className="side_title">
            <Typography variant="h2">Trusted By</Typography>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={4} md={4}>
              <Box className="clientLogo">
                <Box>
                  <img alt="Remy Sharp" src={nestle_logo} />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={4} md={4}>
              <Box className="clientLogo">
                <Box>
                  <img alt="Remy Sharp" src={futtaim_logo} />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={4} md={4}>
              <Box className="clientLogo">
                <Box>
                  <img alt="Remy Sharp" src={Glencore_logo} />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={4} md={4}>
              <Box>
                <Box className="clientLogo2">
                  <img alt="Remy Sharp" src={gamble_logo} />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={4} md={4}>
              <Box className="clientLogo">
                <Box>
                  <img alt="Remy Sharp" src={dl_logo} />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={4} md={4}>
              <Box className="clientLogo">
                <Box>
                  <img alt="Remy Sharp" src={zara_Logo} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
};

export default Client;
